<template>
  <v-layout>
    <v-flex xs12 sm12 md12 lg10 offset-lg1>
      <v-container fluid>
        <v-card>
          <v-card-title>
            <h3 class="headline pa-1">{{ $t('school.TITLE') }}</h3>
            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              :label="$t('forms.SEARCH')"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
          </v-card-title>
          <v-data-table
            v-bind:headers="headers"
            v-bind:search="search"
            :items="orderedSchoolsList"
            v-bind:pagination.sync="pagination"
            :rows-per-page-text="$t('results.table.ROWSPERPAGE')"
            :rows-per-page-items="rowsPageItems"
            class="elevation-1">
            <template slot="items" slot-scope="props">
              <tr style="cursor: pointer;" @click="props.expanded = !props.expanded">
                <!--<td v-if="props.expanded"><v-icon>expand_less</v-icon></td>
                <td v-else><v-icon>expand_more</v-icon></td>-->
                <td></td>
                <td class="text-xs-left">{{props.item.name}}</td>
                <td class="text-xs-right">{{props.item.town}}, {{props.item.country}}</td>
                <td class="text-xs-right">{{$t('school_type.'+findItemById(schoolTypes, props.item.schoolType).name)}}</td>
                <td class="text-xs-right"><v-btn icon v-on:click="$router.push({ name: 'School', params: {schoolId: props.item.id} })"><v-icon>edit</v-icon></v-btn></td>
              </tr>
            </template>
            <!--<template slot="expand" slot-scope="props">
              <v-layout class="text-xs-center">
                <v-flex xs10 offset-xs1>
                  <v-layout class="text-xs-center">
                    <v-flex xs4><v-card><v-card-text><v-icon>email</v-icon><span class="ml-2">{{props.item.town}}</span></v-card-text></v-card></v-flex>
                    <v-flex xs4><v-card><v-card-text><v-icon>public</v-icon><span class="ml-2">{{props.item.country}}</span></v-card-text></v-card></v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </template>-->
          </v-data-table>
        </v-card>
      </v-container>
    </v-flex>
    <v-btn fab large bottom right fixed class="warning" @click.native="$router.push({name: 'NewSchool'})"><v-icon>add</v-icon></v-btn>
    <v-btn fab large bottom left fixed class="warning" v-on:click="$router.push({ name: 'Home' })"><v-icon>arrow_back</v-icon></v-btn>
  </v-layout>
</template>
<script>
  import {SchoolResource} from '../../api/school'
  import {SchoolTypeResource} from '../../api/school_type'
  console.log('Cargo Schoolsvue')
  export default {
    name: 'schools',
    data () {
      console.log('Wait for data')
      return {
        variable: 'value',
        search: '',
        schoolList: '',
        schoolsList: [],
        sortOptions: {
          orderField: 'name',
          direction: 'asc'
        },
        pagination: {
          sortBy: 'id',
          descending: true
        },
        schoolTypes: [],
        headers: [
          {},
          {
            text: this.$t('headers.schools.NAME'),
            align: 'left',
            value: 'name'
          },
          { text: this.$t('headers.schools.ADDRESS'), value: 'postalAddress', align: 'right' },
          { text: this.$t('headers.schools.TYPE'), value: 'schoolType', align: 'right' }
        ],
        rowsPageItems: [10, 20, 30, { text: 'All', value: -1 }]
      }
    },
    created () {
      SchoolTypeResource().get().then(
        response => {
          this.schoolTypes = response.data
        },
        response => {
          console.log('error')
        }
      )
      SchoolResource().get().then(response => {
        this.schoolsList = response.body
      }, response => {

      })
    },
    computed: {
      orderedSchoolsList: function () {
        return this._.orderBy(this.schoolsList, this.sortOptions.orderField, this.sortOptions.direction)
      }
    },
    methods: {
      reOrder (object) {
        this.sortOptions.orderField = object.name
        this.sortOptions.direction = object.type
      },
      findItemById: function (collection, itemId) {
        return this._.find(collection, function (i) {
          return i.id === itemId
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/schools/Schools.vue